import {
  getInstantPromotionsAdminAPI,
  addInstantPromotionAdminAPI,
  deactivateInstantPromotionAdminAPI,
  removeAndDeactivateInstantPromotionAdminAPI,
} from "./api";

export function getInstantPromotionsAdmin() {
  return new Promise((resolve, reject) => {
    getInstantPromotionsAdminAPI()
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}

export function addInstantPromotionAdmin(data) {
  return new Promise((resolve, reject) => {
    addInstantPromotionAdminAPI(data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}

export function deactivateInstantPromotionAdmin(data) {
  return new Promise((resolve, reject) => {
    deactivateInstantPromotionAdminAPI(data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}

export function removeAndDeactivateInstantPromotionAdmin(data) {
  return new Promise((resolve, reject) => {
    removeAndDeactivateInstantPromotionAdminAPI(data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}
